import classNames from 'classnames';
import { memo } from 'react';
import { ReportBlockNodes } from './nodes';
import { useReportBlockCtx } from './report-block-ctx';
import { ReportBlockTitle } from './ReportBlockTitle';

export const ReportBlockHeader = memo(() => {
  const { nodes, size = 'medium', headerClassName, paginationId } = useReportBlockCtx();

  return (
    <div
      className={classNames('flex', headerClassName, {
        'hidden-on-screenshot': nodes?.exportSummary,
        'flex-row items-center': !nodes?.bulkActions,
        'flex-col gap-3 sm:gap-4.5px': nodes?.bulkActions,
      })}
    >
      {nodes?.bulkActions && <ReportBlockTitle />}
      <div
        className={classNames('invisible-on-screenshot flex items-center flex-wrap justify-end w-full', {
          'gap-1.5': size === 'small',
          'gap-4.5px': size === 'medium',
        })}
      >
        {!nodes?.bulkActions && <ReportBlockTitle />}
        {nodes?.bulkActions && <div className='mr-auto'>{nodes?.bulkActions}</div>}
        {nodes?.rightSideJSX}
        {nodes?.datePicker}
        <ReportBlockNodes />
        {nodes?.pagination ? (
          <div className='sm:basis-[100%] flex justify-end'>{nodes.pagination}</div>
        ) : (
          <div className='sm:basis-[100%] flex justify-end empty:hidden min-w-fit' id={paginationId}></div>
        )}
        {nodes?.dataViewButton}
      </div>
    </div>
  );
});

export const ReportBlockSubHeader = ({ className }: { className?: string }) => {
  const { nodes } = useReportBlockCtx();

  return (
    <div className={classNames('mb-18px', className, { 'hidden-on-screenshot': nodes?.exportSummary })}>
      {nodes?.segments}
      {nodes?.appliedFilters}
    </div>
  );
};
